import { render, staticRenderFns } from "./LandSummaryTable.vue?vue&type=template&id=02b2c716&scoped=true&"
import script from "./LandSummaryTable.vue?vue&type=script&lang=js&"
export * from "./LandSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./LandSummaryTable.vue?vue&type=style&index=0&id=02b2c716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b2c716",
  null
  
)

export default component.exports